<template>
    <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>                
                <div class="alert-icon">
                  <i class="fa fa-check-circle-o text-success"></i>
                </div>
                <h4 class="text-center">
                  Cambiar Correo Electrónico                
                </h4>
                <h5
                    class="text-muted text-center"
                  >Su correo electrónico actual es: {{emailagente}}</h5>
                <hr/>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-envelope"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="email"
                    class="form-control"
                    placeholder="Nuevo E-Mail"
                    v-model="payload.nuevo_email"                    
                  />
                </b-input-group>
                
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Ingrese su Contraseña para validar su identidad"
                    autocomplete="current-password"
                    v-model="payload.pass"
                    :state="payload.pass.length > 0 ? payload.pass.length >= 8: null"
                  />
                </b-input-group>
                
                <b-row>
                  <b-tooltip placement="lefttop" target="enviar-btn" triggers="hover">Se enviara mail de solicitud para los cambios, los mismos no son automáticos.</b-tooltip>
                  <b-col class="text-center ">
                    <b-button id="enviar-btn" variant="secondary" class="px-4 btn-action" @click="cambiarClave()">
                      <i></i> Enviar
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            payload: {
                cod_agente: 0,
                nuevo_email: '',
                actual_email: '',
                pass: ''
            }
        }
    },
    computed:{
      emailagente(){
        return this.$store.state.auth.email;
      }
    },
    methods: {
        cambiarClave(){
            let userauth = JSON.parse(sessionStorage.getItem('auth'))
            this.payload.actual_email = this.$store.state.auth.email;
            this.payload.cod_agente = userauth.cod_agente?userauth.cod_agente:userauth.email;
            this.payload.identificador = userauth.cod_agente?'codigo':'email';
            

            if (this.payload.pass.length == 0){
              this.$toast.error('Debe ingresar su contraseña para validar su identidad.', 'Error');
              return;
            } 

            if (this.payload.nuevo_email.length == 0){
              this.$toast.error('Debe ingresar su nuevo correo electronico para iniciar el tramite.', 'Error');
              return;
            } 
              
            let loading = this.$loading.show();  
            this.$api.post('auth/changeemail', this.payload)
                    .then(r => {
                        this.$toast.success('Su solicitud fue enviada con exito.', 'Exito');                        
                        loading.hide();
                        this.$router.push('/');
                    })
                    .catch( e => {
                       this.$toast.error(e.response.data.message, 'Error');     
                       loading.hide();
                    })
                     
        }
    }
}
</script>